import React from "react"

const Airports = ({ searchGroup, dataConfig, results, searchQuery, setMatches, isZeroState, noResults, trackProductClick }) => {
  if (!results || results.length === 0) return null
  if (results && results.length > 0) {
    const isAllZeroData = results.every((element) => element.isZeroData === true)
    if ((!isZeroState || noResults) && isAllZeroData) return null
  }
  return (
    <div className="col- mx-2">
      <h5>
        {searchGroup} ({results.count})
      </h5>
      <ul className="list-group">
        {results.map((result) => {
          const text = `${result.Name}, ${result.City}, ${result.Country} (${result.Iata})`
          const url = `https://www.google.com/maps/@?api=1&map_action=map&center=${result.Latitude},${result.Longitude}&zoom=13&query=${text}`
          // https://www.google.com/maps/@?api=1&map_action=map&center=-33.712206,150.311941&zoom=12
          const highlight = setMatches(text, searchQuery, 4)

          return (
            <li className="list-group-item" key={result.Iata}>
              <a href={url} target={"_blank"} onClick={trackProductClick} rel="noreferrer">
                {highlight.parts.map((part, index) => {
                  const className = part.highlight ? "query" : null
                  return (
                    <span className={className} key={index}>
                      {part.text}
                    </span>
                  )
                })}
              </a>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default Airports
